import styled from 'styled-components';

export const AppContainer = styled.div`
    display: flex;
    height: 100vh;
`;
